import Parameter from '../Parameter';
import { EnumGridPanelData } from '../Enums/EnumGridPanelData';

export default class GridPanelField extends Parameter {

    public Data: EnumGridPanelData;

    /**
     * Dictionnaire de Dictionnaire
     * @key PersistentId
     * @value Nom / Valeur
     */
    public Options: Array<{ Key: string, Value: Array<{ Key: string, Value: string }> }>;

    // Nombre de ligne par page
    public PageSize: number;

    /**
     * Constructeur GridPanel
     * @param Name 
     * @param Label 
     * @param Type 
     * @param EmptyText 
     * @param Selected 
     * @param Option 
     * @param Listeners 
     * @param Data Extends
     * @param Options Extends
     * @param PageSize Extends
     */
    public constructor(Name: string = '', Label: string = '', Type: string = 'GridPanel', EmptyText: string = '', Selected: string = '', Option: object = {}, Listeners: Array<{ key: string, value: string }> = [], Data: EnumGridPanelData = EnumGridPanelData.Object, Options: Array<{ Key: string, Value: Array<{ Key: string, Value: string }> }> = [], PageSize: number = 5 ) {
        super(Name, Label, Type, EmptyText, Selected, Option, Listeners);
        this.Data = Data;
        this.Options = Options;
        this.PageSize = PageSize;
    }

    //#region Methode Static
    
    // Enregistre la sous-class dans la class Parent
    static {
        Parameter.registerSubclass(GridPanelField); 
    }

    //#endregion
    
    /**
     * Check si GridPanel à des valeurs
     * @returns boolean
     */
    override HasValue(): boolean {
        return this.Options.length > 0;
    }
    
    /**
     * Propriété filtrées pour la création d'un objet GridPanel
     * @returns Dictionnaires Nom / Valeurs
     */
    override getProperties(): Array<[string, any]>{
        return Object.entries(this).filter(([key]) => 
            this.keysToFilter.includes(key) )
    }

    // Créations des clés pour filtrer les propriétés de GridPanel
    override keysToFilter: string[] =  ['Data', 'PageSize'];

    override create() : GridPanelField{
        return new GridPanelField(this.Name, this.Label, this.Type, this.EmptyText, this.Selected, this.Option, this.Listeners, this.Data, this.Options, this.PageSize)
    }
}